import type {ReactNode} from 'react';
import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';

export function StaticPage({
  eyebrow,
  title,
  children,
}: {
  eyebrow: string;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className={`max-w-3xl space-y-4 ${POSTHOG_UNMASK_CLASS}`}>
      <p className='text-sm font-semibold uppercase tracking-wide text-neutral-400'>{eyebrow}</p>
      <h1 className='text-3xl font-bold text-neutral-900'>{title}</h1>
      <div className='rounded-xl border border-dashed border-neutral-300 bg-white p-8 text-neutral-500'>
        {children ?? 'Content for this page is coming in a later ticket.'}
      </div>
    </div>
  );
}
